"use client"

import FileUploadInput from "@/components/account/input/MultipleFileUploadInput";
import TextInput from "@/components/account/input/TextInput";
import { MultilingualInput } from "@/components/account/widgets/GlobalWidgetEditor";

import { useDictionary } from "@/core/hooks/use-dictionary";
import { Control, Controller, FieldErrors, UseFormRegister } from "react-hook-form";


interface VideoBannerWidgetProps {
    widgetIndex: number;
    name: string;
    control: Control<any>;
    register: UseFormRegister<any>;
    errors: FieldErrors<any>;
    disabled?: boolean;
}

export const VideoBannerWidget = ({
    widgetIndex,
    name,
    control,
    register,
    errors,
    disabled,
}: VideoBannerWidgetProps) => {
    const { dictionary } = useDictionary();

    const getError = (path: string) => {
        const errorPath = path.split('.');
        let current = errors;
        for (const key of errorPath) {
            if (current && typeof key === 'string' && key in current) {
                current = (current as any)[key];
            } else {
                return undefined;
            }
        }
        return (current as any)?.message;
    };

    const imageError = getError(`${name}.${widgetIndex}.image`) as string | undefined;

    return (
        <div className="space-y-4">
            <Controller
                control={control}
                name={`${name}.${widgetIndex}.image`}
                render={({ field }) => (
                    <FileUploadInput
                        accept="image/*,video/*"
                        disabled={disabled}
                        onUploadSuccess={(image) => {
                            if (!Array.isArray(image) && image) field.onChange(image);
                        }}
                        defaultImages={
                            field.value
                                ? [
                                    {
                                        ...field.value,
                                        name: field.value.name || '',
                                        description: field.value.description || '',
                                    },
                                ]
                                : []
                        }
                        onDefaultRemove={() => field.onChange(undefined)}
                        error={imageError}
                    />
                )}
            />
            <MultilingualInput
                baseName={`${name}.${widgetIndex}.title`}
                label={dictionary.forms?.title}
                register={register}
                errors={errors}
                disabled={disabled}
            />
            <MultilingualInput
                baseName={`${name}.${widgetIndex}.buttonContent`}
                label={dictionary.forms?.buttonContent}
                register={register}
                errors={errors}
                disabled={disabled}
            />
            <TextInput
                name={`${name}.${widgetIndex}.link`}
                label={dictionary.forms?.link}
                placeholder={dictionary.forms?.link}
                register={register}
                errors={errors}
                disabled={disabled}
            />
        </div>
    );
};